export interface IntervalCommonProps {
  r: number;
  g: number;
  b: number;
  units?: Unit | string;
  hex?: string;
}

export interface IntervalWithValue extends IntervalCommonProps {
  value: string;
}

export interface IntervalWithStringValue extends IntervalCommonProps {
  stringValue: string;
}

export type Interval = IntervalWithValue | IntervalWithStringValue;

export const isIntervalWithStringValue = (interval: Interval): interval is IntervalWithStringValue =>
  'stringValue' in interval && typeof interval.stringValue === 'string';

export const isIntervalWithValue = (interval: Interval): interval is IntervalWithValue =>
  'value' in interval && typeof interval.value === 'string';

export type Unit = {
  cropNominalWeight: number;
  intervals: Interval[];
  key: string;
  singularKey: string;
};
